export enum Currency {
  inr = 'inr',
  gbp = 'gbp',
  eur = 'eur',
  aed = 'aed',
  usd = 'usd',

  //intl
  ch = 'ch',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- Iceland (is) intentionally prices in eur
  is = 'eur',

  // customs
  hk_usd = 'hk_usd',

  // Tesla pricing currencies
  aud = 'aud',
  brl = 'brl',
  bgn = 'bgn',
  cad = 'cad',
  clp = 'clp',
  cny = 'cny',
  cop = 'cop',
  czk = 'czk',
  dkk = 'dkk',
  egp = 'egp',
  hkd = 'hkd',
  huf = 'huf',
  idr = 'idr',
  ils = 'ils',
  jpy = 'jpy',
  krw = 'krw',
  kzt = 'kzt',
  mxn = 'mxn',
  myr = 'myr',
  ngn = 'ngn',
  nok = 'nok',
  nzd = 'nzd',
  pen = 'pen',
  php = 'php',
  pkr = 'pkr',
  pln = 'pln',
  qar = 'qar',
  ron = 'ron',
  rub = 'rub',
  sar = 'sar',
  sek = 'sek',
  sgd = 'sgd',
  thb = 'thb',
  try = 'try',
  twd = 'twd',
  tzs = 'tzs',
  vnd = 'vnd',
  zar = 'zar',
}
